import React from 'react'

import clsx from 'clsx'

import CtaButton from 'components/CtaButton'
import Paper from 'components/Paper'
import { useEventContext } from 'context/EventContext'

import AlternativeListing from './components/AlternativeListing'

import classes from './AlternativesSection.module.scss'

/** @type {import("./types").default} */
const CompareAlternatives = ({
  ctaUrl = null,
  isCtaFullWidth = false,
  isCtaTextButton = false,
  items = [],
  isTwoCols,
}) => {
  const { addEvent } = useEventContext()

  return (
    <Paper
      className={clsx('AlternativesSection', classes.root, {
        [classes.twoCols]: isTwoCols,
      })}
      elevation={0}
    >
      <div>
        {items.map((listing, index) => {
          return <AlternativeListing key={index} listing={listing} listingPosition={index} />
        })}
      </div>
      {ctaUrl && (
        <div className={clsx(classes.actions, classes.ctaButtonOnExperiment)}>
          <CtaButton
            data-testid="alternatives-view-all-cta"
            fullWidth={isCtaFullWidth}
            label="SEE MORE APPS"
            secondary
            href={ctaUrl}
            variant={isCtaTextButton ? 'text' : 'contained'}
            {...addEvent({
              engagementComponent: 'product_alternatives',
              engagementDestination: 'go-to_product_alternatives',
              engagementDetails: 'button_see-more-apps',
              name: 'engagement_product_click',
            })}
          />
        </div>
      )}
    </Paper>
  )
}
export default CompareAlternatives
